import type { DomainInTree } from "@/stores/domains-store";
import type { ProcessInTree } from "@/stores/processes-store";
import type { ProductInTree } from "@/stores/products-store";

/**
 * The worktree data fields copied verbatim onto each tree menu node.
 *
 * Kept as pure helpers (no runtime imports — the type imports are erased) so the
 * copy is unit-testable without instantiating the Lit `<c-stekz-tree>`
 * component, which is deeply coupled to the app runtime. Critically, this
 * includes `diff_status`: it drives the thread diff indicators
 * (added/modified/removed), and was once silently dropped from the menu copy —
 * routing every menu-node build through here stops that regressing again.
 *
 * The relational fields (parent/children) are wiring, not data, and stay in the
 * component's tree-building loop.
 */
export function domainMenuFields(domain: DomainInTree) {
    return {
        name: domain.name,
        identity: domain.identity,
        order_index: domain.order_index,
        diff_status: domain.diff_status,
    };
}

export function productMenuFields(product: ProductInTree) {
    return {
        name: product.name,
        identity: product.identity,
        order_index: product.order_index,
        diff_status: product.diff_status,
    };
}

export function processMenuFields(process: ProcessInTree) {
    return {
        name: process.name,
        identity: process.identity,
        order_index: process.order_index,
        diff_status: process.diff_status,
    };
}
